<template>
  <!-- <Teleport to="body"> -->
    <div class="c-modal-cover" v-if="visible">
    <div ref="dialog" tabindex="-1" role="dialog" aria-modal="true" :aria-label="title" class="c-modal-container" :style="{width:width+'px',height:height?height+'px':undefined}">
      <div class="c-modal-header">
        <div class="c-modal-title">
          {{ title }}
        </div>
        <div class="c-modal-icons">
          <button type="button" class="c-modal-close" aria-label="关闭" @click="closeModal"><svg-icon icon="close"></svg-icon></button>
        </div>
      </div>
      <div class="c-modal-body" :class="{ 'flex-center': centered }">
        <slot></slot>
      </div>
      <div class="c-modal-footer">
        <slot name="footer">
          <div class="c-modal-footer-btns">
            <CButton text="返回" @click="closeModal"></CButton>
          </div>
        </slot>
      </div>
    </div>
  </div>
  <!-- </Teleport> -->
</template>
<script lang="ts">
export default {
  name:'CModal'
}
</script>
<script lang="ts" setup>
import CButton from '../cButton/CButton.vue';
import {ref,watch,nextTick,onBeforeUnmount} from 'vue'
import {trapModalFocus} from '@/utils/modalFocus'
interface ModalProps {
  width?: number,
  height?: number,
  title?: string,
  visible: boolean,
  centered?: boolean
}
const props = withDefaults(defineProps<ModalProps>(), {
  width: 600,
  centered: false
})
const emit = defineEmits(['update:visible'])
const dialog=ref<HTMLElement|null>(null)
let releaseFocus:(()=>void)|undefined,focusGeneration=0
watch(()=>props.visible,async visible=>{
  const run=++focusGeneration;releaseFocus?.();releaseFocus=undefined
  if(!visible)return
  await nextTick();if(run!==focusGeneration || !props.visible || !dialog.value)return
  releaseFocus=trapModalFocus(dialog.value,()=>emit('update:visible',false))
},{immediate:true})
onBeforeUnmount(()=>{focusGeneration++;releaseFocus?.()})
const closeModal = () => {
  emit('update:visible', false)
}
</script>
<style scoped lang="scss">
.c-modal-cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-modal-container {
  position: relative;
  display: flex;
  font-size: 14px;
  max-width:calc(100vw - 32px);
  max-height:calc(100vh - 32px);
  background: white;
  flex-direction: column;
  border-radius: 5px;
}

.c-modal-header {
  flex:0 0 44px;
  height:44px;
  // color: white;
  line-height: 44px;
  padding: 0px 24px;
  border-radius: 5px 5px 0 0;
  // background: linear-gradient(to right, #0cd7bd, #52c5f3);
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
  font-weight: bold;

  .c-modal-icons {
    cursor: pointer;
  }
}

.c-modal-body {
  white-space:normal;
  overflow-wrap:anywhere;
  padding:16px;
  flex:1 1 auto;
  min-height:0;
  overflow:auto;
  overscroll-behavior:contain;
}

.c-modal-footer {
  flex:0 0 auto;
  width:100%;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  text-align: right;
  border-top: 1px solid #e8e8e8;
}

.disabledEdit {
  pointer-events: none;
}
.c-modal-close{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;padding:4px;border:0;border-radius:5px;background:transparent;color:#718096;cursor:pointer;vertical-align:middle}.c-modal-close:hover{background:var(--admin-skin-soft,#edf3f9);color:var(--activeColor,#1890ff)}
</style>
